import { useState, useEffect } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('pwa-install-dismissed') === '1');

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt || dismissed) return null;

  async function handleInstall() {
    if (!deferredPrompt) return;
    await deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
  }

  function handleDismiss() {
    localStorage.setItem('pwa-install-dismissed', '1');
    setDismissed(true);
  }

  return (
    <div style={{
      position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 200,
      background: 'var(--vs1)', border: '1px solid rgba(29,158,117,.35)',
      borderRadius: 10, padding: '12px 16px',
      display: 'flex', alignItems: 'center', gap: 12,
      boxShadow: '0 4px 20px rgba(0,0,0,.35)',
    }}>
      <div style={{ fontSize: '1.4rem', flexShrink: 0 }}>📲</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '0.83rem', fontWeight: 700, color: 'var(--shell-text)' }}>Add Relay to Home Screen</div>
        <div style={{ fontSize: '0.73rem', color: 'var(--shell-muted)', marginTop: 2 }}>Get the full app experience</div>
      </div>
      <button
        onClick={handleInstall}
        style={{
          background: 'var(--v1)', color: 'var(--text-on-accent)', border: 'none',
          borderRadius: 6, padding: '7px 14px',
          fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer', flexShrink: 0,
        }}
      >
        Install
      </button>
      <button
        onClick={handleDismiss}
        style={{
          background: 'transparent', border: 'none', color: 'var(--shell-xs)',
          fontSize: '1.1rem', cursor: 'pointer', padding: '4px', flexShrink: 0, lineHeight: 1,
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
